import React, { useState } from 'react';

import AppBar from 'components/AppBar';
import ApplicationOverlayContent from 'components/ApplicationLayout/ApplicationOverlayContent';
import { Desktop, Mobile } from 'components/Responsive';
import ScreenHeader from 'components/ScreenHeader';
import { CountryCode } from 'components/Selects/CountryCodeSelect';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { htmlT } from 'utils/generic';

import {
  Container,
  CenteredImage,
  Header,
  Subheader,
  TermsContainer,
  TermsTitle,
  Checkbox,
  NextButton,
  ButtonsContainer,
} from '../../styles';
import Privacy from './documents/privacy';
import Terms from './documents/terms';
import { ChooseLanguage, DocumentTextContainer } from './styles';

interface Props {
  accepted: boolean;
  onSubmit: () => Promise<void>;
  countryCode?: CountryCode | null;
}

const Welcome = ({ accepted, onSubmit, countryCode }: Props) => {
  const { t } = useStoreTranslation();

  const [loading, setLoading] = useState(false);

  const [termsChecked, setTermsChecked] = useState(accepted);
  const [privacyChecked, setPrivacyChecked] = useState(accepted);

  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);

  const openTerms = () => setShowTerms(true);
  const closeTerms = () => setShowTerms(false);

  const openPrivacy = () => setShowPrivacy(true);
  const closePrivacy = () => setShowPrivacy(false);

  const handleToggleTerms = () => setTermsChecked((terms) => !terms);
  const handleTogglePrivacy = () => setPrivacyChecked((privacy) => !privacy);
  const [currentLanguage, setcurrentLanguage] = useState('CO');

  const handleSubmit = async () => {
    setLoading(true);
    await onSubmit();
    setLoading(false);
  };

  const handleChangeLanguage = (type: string) => {
    setcurrentLanguage(type);
  };

  return (
    <>
      <Container>
        <Mobile>
          <CenteredImage marginBottom={48} width={120} src="/corporate/images/logo-netviajes.svg" />
        </Mobile>

        <Header black>{t('invite.welcome.title')}</Header>
        <Subheader>{htmlT(t, 'invite.welcome.subtitle')}</Subheader>

        <TermsContainer>
          <TermsTitle>{t('registrationOnboarding.company.acceptTerms.title')}</TermsTitle>
          <Checkbox checked={termsChecked} onChange={handleToggleTerms} circle size={24}>
            <div id="terms">
              &nbsp;{' '}
              <a href={`${process.env.PUBLIC_URL}/terminos_condiciones_v2.pdf`} target="_blank" rel="noreferrer">
                {t('registrationOnboarding.company.acceptTerms.terms')}
              </a>
            </div>
          </Checkbox>

          <Checkbox checked={privacyChecked} onChange={handleTogglePrivacy} circle size={24}>
            <div id="terms">
              &nbsp;{' '}
              <a href={`${process.env.PUBLIC_URL}/terminos_condiciones_v2.pdf`} target="_blank" rel="noreferrer">
                {t('registrationOnboarding.company.acceptTerms.privacy')}
              </a>
            </div>
          </Checkbox>
        </TermsContainer>

        <ButtonsContainer left>
          <NextButton
            disabled={!termsChecked || !privacyChecked || loading}
            loading={loading}
            noMargin
            onClick={handleSubmit}
          >
            {t('invite.nextButton')}
          </NextButton>
        </ButtonsContainer>
      </Container>
      <ApplicationOverlayContent sidebar onClose={closeTerms} width={1000} show={showTerms}>
        <>
          <Mobile>
            <AppBar noGoBack rightIcon="/corporate/images/close.svg" rightAction={closeTerms}>
              {t('registrationOnboarding.company.termsTitle')}
            </AppBar>
          </Mobile>
          <Desktop>
            <ScreenHeader title={t('registrationOnboarding.company.termsTitle')} />
          </Desktop>
          <ChooseLanguage
            className={currentLanguage}
            options={[
              { label: 'Colombia', value: 'CO', testId: 'language-co' },
              { label: 'Brasil', value: 'BR', testId: 'language-br' },
              { label: 'Argentina', value: 'AR', testId: 'language-ar' },
              { label: 'Mexico', value: 'MX', testId: 'language-mx' },
            ]}
            active={currentLanguage}
            onChange={handleChangeLanguage}
          />
          <DocumentTextContainer>
            <Terms country={currentLanguage} />
          </DocumentTextContainer>
        </>
      </ApplicationOverlayContent>
      <ApplicationOverlayContent sidebar onClose={closePrivacy} width={1000} show={showPrivacy}>
        <>
          <Mobile>
            <AppBar noGoBack rightIcon="/corporate/images/close.svg" rightAction={closePrivacy}>
              {t('registrationOnboarding.company.privacyTitle')}
            </AppBar>
          </Mobile>
          <Desktop>
            <ScreenHeader title={t('registrationOnboarding.company.privacyTitle')} />
          </Desktop>
          <ChooseLanguage
            className={currentLanguage}
            options={[
              { label: 'Colombia', value: 'CO', testId: 'language-co' },
              { label: 'Brasil', value: 'BR', testId: 'language-br' },
              { label: 'Argentina', value: 'AR', testId: 'language-ar' },
              { label: 'Mexico', value: 'MX', testId: 'language-mx' },
            ]}
            active={currentLanguage}
            onChange={handleChangeLanguage}
          />
          <DocumentTextContainer>
            <Privacy country={currentLanguage} />
          </DocumentTextContainer>
        </>
      </ApplicationOverlayContent>
    </>
  );
};

export default Welcome;
